// Import all images
import logo from '../assets/images/eps-logo.png';
import devices from '../assets/images/devices.webp';
import dragDrop from '../assets/images/drag-drog.webp';
import emailAnalytics from '../assets/images/email-analytics.webp';
import emailDesignTesting from '../assets/images/email-design-testing.webp';
import emailDesign from '../assets/images/email-design.webp';
import epsCatAnalytic from '../assets/images/eps-cat-analytic.webp';
import epsCatContact from '../assets/images/eps-cat-contact.webp';
import epsCatSpam from '../assets/images/eps-cat-spam.webp';
import epsCat from '../assets/images/eps-cat.webp';
import govLogo from '../assets/images/gov-logo.png';
import loweLogo from '../assets/images/lowe-logo.png';
import marker from '../assets/images/marker.webp';
import noSpamBox from '../assets/images/no-spam-box.webp';
import powerEmail from '../assets/images/power-email.webp';
import spam1 from '../assets/images/spam-1.webp';
import spam2 from '../assets/images/spam-2.webp';
import tick from '../assets/images/tick.png';
import ua from '../assets/images/ua.webp';
import emailDesign1 from '../assets/images/email-design-1.svg';
import emailDesign2 from '../assets/images/email-design-2.svg';
import emailDesign3 from '../assets/images/email-design-3.svg';
import emailDesign4 from '../assets/images/email-design-4.svg';
import emailDesign5 from '../assets/images/email-design-5.svg';
import emailDesign6 from '../assets/images/email-design-6.svg';
import emailTesting1 from '../assets/images/email-testing-1.svg';
import emailTesting2 from '../assets/images/email-testing-2.svg';
import emailTesting3 from '../assets/images/email-testing-3.svg';
import emailTesting4 from '../assets/images/email-testing-4.svg';
import emailTesting5 from '../assets/images/email-testing-5.svg';
import emailTesting6 from '../assets/images/email-testing-6.svg';
import featuresIcon1 from '../assets/images/features-icon-1.svg';
import featuresIcon2 from '../assets/images/features-icon-2.svg';
import featuresIcon3 from '../assets/images/features-icon-3.svg';
import offers1Icon from  '../assets/images/offers-1-icon.svg';
import offers2Icon from  '../assets/images/offers-2-icon.svg';
import offers3Icon from  '../assets/images/offers-3-icon.svg';
import offers4Icon from  '../assets/images/offers-4-icon.svg';
import offers5Icon from  '../assets/images/offers-5-icon.svg';
import offers6Icon from  '../assets/images/offers-6-icon.svg';
import offers7Icon from  '../assets/images/offers-7-icon.svg';
import spamTestingInterface from '../assets/images/spam-testing-interface.webp';
import notFound from '../assets/images/404.webp';

// Export all images
export const images = {
    logo,
    devices,
    dragDrop,
    emailAnalytics,
    emailDesignTesting,
    emailDesign,
    epsCatAnalytic,
    epsCatContact,
    epsCatSpam,
    epsCat,
    govLogo,
    loweLogo,
    marker,
    noSpamBox,
    powerEmail,
    spam1,
    spam2,
    tick,
    ua,
    emailDesign1,
    emailDesign2,
    emailDesign3,
    emailDesign4,
    emailDesign5,
    emailDesign6,
    emailTesting1,
    emailTesting2,
    emailTesting3,
    emailTesting4,
    emailTesting5,
    emailTesting6,
    featuresIcon1,
    featuresIcon2,
    featuresIcon3,
    offers1Icon,
    offers2Icon,
    offers3Icon,
    offers4Icon,
    offers5Icon,
    offers6Icon,
    offers7Icon,
    notFound,
    spamTestingInterface,
} as const;

// Type for image keys
export type ImageKey = keyof typeof images;

// Function to get image URL
export const getImage = (key: ImageKey): string => {
    if (!(key in images)) {
        throw new Error(`Image key '${key}' not found`);
    }
    return images[key];
};
